module.exports = __webpack_public_path__ + "img/link1.cf8320e3.png";